import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AuditHistory from './audit-history';
import AuditHistoryDetail from './audit-history-detail';
import AuditHistoryUpdate from './audit-history-update';
import AuditHistoryDeleteDialog from './audit-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AuditHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AuditHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AuditHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={AuditHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AuditHistoryDeleteDialog} />
  </>
);

export default Routes;
